import React, { useState, useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import { ObjModal } from '../../../../contexts';
import AddReferral from '../../../Modals/AddReferral';
import { DataGridPro, GridActionsCellItem, GridFooterContainer } from '@mui/x-data-grid-pro';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';


const Referrals = ( { aid, uid, opps, loans } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );
    const [ gridData, setGridData ] = useState( [] );

    useEffect( () => {
        setExpanded( obj.referrals.length > 0 );

        let list = [];
        if ( obj.referrals.length ) {
            obj.referrals.forEach( r => {
                list.push( {
                    id: r.cid,
                    firstname: r.firstname,
                    lastname: r.lastname,
                    firstLead: r.leadDateFirst,
                    lastLead: r.leadDateLast,
                    count: r.leadCount
                } );
            } );
        }
        setGridData( list );
    }, [ obj.referrals ] );

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'referral':
                setModal( <AddReferral /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    let cols = [
        { field: 'name', headerName: 'Lead', flex: 1, renderCell: ( { row } ) => (
            <Link to={`/contact/${row.id}`}>{row.firstname} {row.lastname}</Link>
        ), valueGetter: ( { row } ) => `${row.firstname} ${row.lastname}` },
        { field: 'firstLead', headerName: 'Orig Opp', type: 'date', width: 100, valueFormatter: ( { value } ) => value && new Date( value + 'T12:00:00.000' ).toLocaleDateString() },
        { field: 'lastLead', headerName: 'Latest Opp', type: 'date', width: 100, valueFormatter: ( { value } ) => value && new Date( value + 'T12:00:00.000' ).toLocaleDateString() },
        { field: 'count', headerName: '# Opps', type: 'number', width: 60 }  
    ];

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Referrals from {obj.details.firstname} ({obj.referrals.length})</Typography></Col>
                        {/* <Col xs='auto' className='p-0'>
                            <ObjModal.Provider value={ { openModal, closeModal, setModal } }>
                                <Button size='sm' variant='outline-primary' onClick={ () => handleModal( 'referral' ) }>+ Add</Button>
                            </ObjModal.Provider>
                        </Col> */}
                    </Row>
                </AccordionSummary>
                <AccordionDetails style={ { maxHeight: '250px', overflowY: 'scroll' } }>
                    <Row className='tf-dashboard-li-container overflow-auto pb-2'>
                        <Col>
                            <DataGridPro
                                rows={gridData}
                                columns={cols}
                                disableSelectionOnClick
                                hideFooter={true}
                                autoHeight={true}
                                rowHeight={40}
                            />
                        </Col>
                    </Row>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    opps: state.leadopps.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Referrals );